document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.tabs-ap__btn');
  const panels = document.querySelectorAll('.tabs-ap__panel');

  let currentPanel = panels[0];

  if (currentPanel) {
    currentPanel.classList.add('active');
    gsap.set(currentPanel, { autoAlpha: 1 });
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.getAttribute('data-tab');
      const newPanel = document.getElementById(`tab-panel-${target}`);

      if (!newPanel || newPanel === currentPanel) return;

      buttons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      gsap.to(currentPanel, {
        autoAlpha: 0,
        duration: 0.4,
        onComplete: () => {
          currentPanel.classList.remove('active');
          newPanel.classList.add('active');
          gsap.fromTo(newPanel, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.4 });
          currentPanel = newPanel;
        }
      });
    });
  });

  const popup = document.querySelector('.popup-award');
  const closeBtn = popup.querySelector('.close-popup-award');

  const titleEl = popup.querySelector('.popup-award__title');
  const imgEl = popup.querySelector('.popup-award__img img');
  const descEl = popup.querySelector('.popup-award__description');

  document.querySelectorAll('.open-popup-description').forEach(button => {
    button.addEventListener('click', () => {
      const id = button.dataset.id;
      const title = button.dataset.title;
      const image = button.dataset.image;

      titleEl.textContent = title;
      imgEl.src = image;
      imgEl.alt = title;
      descEl.innerHTML = `<p>Loading...</p>`;

      popup.classList.add('active');

      fetch(`${window.location.origin}/wp-json/custom/v1/ap-description?id=${id}`)
        .then(res => res.json())
        .then(data => {
          descEl.innerHTML = `<p>${data.description}</p>`;
        })
        .catch(() => {
          descEl.innerHTML = `<p>Unable to load description.</p>`;
        });
    });
  });

  closeBtn.addEventListener('click', () => popup.classList.remove('active'));
  popup.addEventListener('click', e => {
    if (e.target === popup) popup.classList.remove('active');
  });
  
});
